import React, { useState, useEffect } from "react";
import moment from "moment-hijri";
import "moment/locale/id";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "../HumanCalculator/MainCalculators";
import imgUrl from "../../../images/current-date.webp"
const TITLE = "Tanggal Hari Ini Masehi dan Hijriah - Mengetahui Tanggal Saat Ini";
const DESCRIPTION =
  "Menampilkan tanggal saat ini dalam kalender Masehi dan Hijriah dengan detail hari dan jam. Mengetahui tanggal hari ini secara akurat menurut kalender Masehi dan Hijriah.";
const KEYWORDS =
  "tanggal hari ini, tanggal masehi, tanggal hijriah, kalender masehi, kalender hijriah, tanggal hari ini masehi, tanggal hari ini hijriah, konversi tanggal";
const OG_URL = "https://do-calculate.com/calculator/id/current-date/";
const indonesianMonths = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];
const indonesianDays = [
  "Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"
];
const indonesianHijriMonths = [
  "Muharram", "Safar", "Rabiul Awal", "Rabiul Akhir",
  "Jumadil Awal", "Jumadil Akhir", "Rajab", "Sya'ban",
  "Ramadhan", "Syawal", "Dzulqa'dah", "Dzulhijjah"
];
moment.locale("id");
function CurrentDateDisplay() {
  const [currentTime, setCurrentTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const dayName = indonesianDays[currentTime.getDay()];
  const day = currentTime.getDate();
  const month = indonesianMonths[currentTime.getMonth()];
  const year = currentTime.getFullYear();
  const gregorianDate = `${dayName}, ${day} ${month} ${year}`;
  let hours = currentTime.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const minutes = currentTime.getMinutes().toString().padStart(2, "0");
  const seconds = currentTime.getSeconds().toString().padStart(2, "0");
  const gregorianTime = `${hours}:${minutes}:${seconds} ${ampm}`;
  const hijriMoment = moment(currentTime);
  const hijriDay = hijriMoment.iDate();
  const hijriMonthIndex = hijriMoment.iMonth();
  const hijriMonth = indonesianHijriMonths[hijriMonthIndex];
  const hijriYear = hijriMoment.iYear();
  const hijriWeekday = hijriMoment.format("dddd");
  const hijriDate = `${hijriWeekday}, ${hijriDay} ${hijriMonth} ${hijriYear}`;
  const hijriTime = hijriMoment.format("hh:mm:ss A");
  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={imgUrl}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4">
          <img
            src={imgUrl}
            alt={
              "Tanggal Hari Ini Masehi dan Hijriah - Mengetahui Tanggal Saat Ini"
            }
            width="300px"
            height="300px"
          />
        </div>
      </div>
      <br />
      <MobileUnderCalAds />
      <div className="row">
        <div className="col-12 col-md-7 calculatorStyle">
          <div className="p-3 mb-2 bg-success text-white text-center rounded">
            <h1 style={{ fontSize: "20px" }}>Tanggal Hari Ini Masehi dan Hijriah</h1>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="card h-100 border-success">
                <div className="p-3 mb-2 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "16px" }}>Tanggal Masehi</h2>
                </div>
                <div className="text-center">
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#28a745" }}>
                    {gregorianDate}
                  </div>
                  <div className="mt-2" style={{ fontSize: "18px" }}>
                    {gregorianTime}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card h-100 border-success">
                <div className="p-3 mb-2 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "16px" }}>Tanggal Hijriah</h2>
                </div>
                <div className="text-center">
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#28a745" }}>
                    {hijriDate}
                  </div>
                  <div className="mt-2" style={{ fontSize: "18px" }}>
                    {hijriTime}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="alert alert-info mt-4">
            <p className="mb-0">
              Bagian ini menampilkan tanggal saat ini menurut kalender Masehi (Gregorian) dan kalender Hijriah (Lunar) dengan waktu saat ini. Data diperbarui secara otomatis sesuai dengan waktu perangkat Anda.
            </p>
          </div>

        </div>

        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row">
        <RelatedLinks />
        <hr />
      </div>
      <div className="row">
        <div className="col-12 col-md-8" >
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Tanggal Hijriah dan Masehi Hari Ini - Konversi Tanggal Antara Kedua Kalender</div>
              <div className="info-section-body">
                <div>
                  <h3 className="text-success">Tanggal Hari Ini Hijriah dan Masehi dengan Waktu Negara Anda</h3>
                  <p>
                    Layanan kami menyajikan tampilan akurat tanggal Hijriah dan Masehi hari ini sesuai dengan waktu lokal Anda. Kami menyediakan tanggal dalam berbagai format berbeda termasuk format numerik lengkap, format campuran (angka dan teks), dan format teks lengkap menggunakan ejaan untuk memastikan tingkat akurasi dan kejelasan tertinggi.
                  </p>
                  <div className="row mt-4">
                    <div className="col-md-6 mb-3">
                      <div className="border p-3 h-100 rounded">
                        <h4 className="text-success">Kalender Masehi (Tanggal Gregorian)</h4>
                        <p style={{ textAlign: "justify" }}>
                          Kalender Masehi adalah sistem kalender yang paling banyak digunakan secara global, didasarkan pada siklus bumi mengelilingi matahari (365,25 hari). Ini digunakan dalam transaksi resmi internasional dan dimulai dari tahun kelahiran Kristus. Ini dianggap sebagai kalender resmi di sebagian besar negara Arab kecuali Kerajaan Arab Saudi.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border p-3 h-100 rounded">
                        <h4 className="text-success">Kalender Hijriah (Tanggal Lunar Islam)</h4>
                        <p style={{ textAlign: "justify" }}>
                          Kalender Hijriah adalah kalender resmi di Kerajaan Arab Saudi, didasarkan pada siklus bulan (29,5 hari). Ini digunakan untuk menentukan acara-acara Islam seperti Ramadhan dan Haji. Dimulai dari hijrah Nabi Muhammad SAW dan lebih pendek 11 hari per tahun dibandingkan kalender Masehi.
                        </p>
                      </div>
                    </div>
                  </div>
                  <h3 className="mt-4">Bagaimana Tanggal Hijriah dan Masehi Hari Ini Ditentukan?</h3>
                  <p>
                    Dalam menampilkan tanggal Masehi, kami mengandalkan waktu sistem operasi sesuai dengan zona waktu Anda. Adapun konversi antara kedua tanggal dilakukan melalui algoritma perhitungan akurat yang dikembangkan khusus untuk memastikan kecocokan tanggal Hijriah dengan Masehi dengan akurasi tinggi, dengan mempertimbangkan perbedaan waktu antar negara.
                  </p>
                  <h4>Akurasi Konversi Antara Tanggal Hijriah dan Masehi</h4>
                  <p>
                    Proses konversi antara kedua sistem diaudit secara berkala untuk memastikan kecocokan tanggal yang ditampilkan dengan referensi astronomi yang terakreditasi. Kami memastikan data diperbarui sesuai dengan perhitungan astronomi terbaru.
                  </p>
                  <h3 className="mt-4">Fitur Layanan Tampilan Tanggal Hari Ini</h3>
                  <h4>Menampilkan Tanggal Sesuai Waktu Lokal Anda</h4>
                  <p>
                    Kami menampilkan tanggal Hijriah dan Masehi sesuai dengan waktu negara tempat Anda terhubung. Jika Anda berada di luar dunia Arab, kami menyediakan opsi untuk menampilkan waktu universal dengan pemberitahuan zona waktu.
                  </p>
                  <h4>Berbagai Format Tanggal</h4>
                  <p>
                    Kami menyediakan tanggal dalam berbagai format untuk memenuhi berbagai kebutuhan: numerik lengkap (1445/12/25), campuran (25 Dzulhijjah 1445), teks lengkap (kedua puluh lima Dzulhijjah tahun seribu empat ratus empat puluh lima Hijriah).
                  </p>
                  <h4>Alat Konversi Tanggal Antara Hijriah dan Masehi</h4>
                  <p>
                    Anda dapat dengan mudah mengkonversi antara kedua tanggal melalui alat interaktif kami yang memberikan hasil instan dan akurat dengan kemampuan untuk menampilkan tanggal mendatang untuk acara-acara Islam.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
export default CurrentDateDisplay;